import { connect } from 'react-redux'
import { selectIsMerging } from 'selectors/page/selectIsMerging'
import { doOpenTicketPage } from 'actions/pages'
import { doOpenTicketMergeDrawer } from 'actions/tickets'
import { selectCurrentTicketId } from 'selectors/tickets/current/selectCurrentTicketId'
import View from './view'

const select = state => ({
  ticketId: selectCurrentTicketId(state),
  open: selectIsMerging(state),
})

const perform = dispatch => ({
  onOpen: ticketId => dispatch(doOpenTicketMergeDrawer(ticketId)),
  onClose: ticketId => dispatch(doOpenTicketPage(ticketId)),
})

export default connect(select, perform)(View)
